import Configuration from '../config';

async function request(path, token, payload, method) {
  try {
    const response = await fetch(`${Configuration.apiEndPoint}/admin/p2p/${path}`, {
      method: method || (payload === undefined ? 'GET' : 'PUT'),
      headers: {Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
      cache: 'no-store',
      ...(payload === undefined ? {} : {body: JSON.stringify(payload)})
    });
    const json = await response.json();
    if (!response.ok) throw new Error(json.error || 'p2p_request_failed');
    return json;
  } catch (error) {
    // Never log payloads, credentials or raw response bodies.
    const code = error.message && /^(p2p_|admin_required|no_authorization_header)/.test(error.message)
      ? error.message : 'p2p_request_failed';
    throw new Error(code);
  }
}

export const getP2pCatalog = token => request('catalog', token);
export const getP2pDevices = token => request('devices', token);
export const getP2pField = (fieldId, token) => request(`fields/${fieldId}`, token);
export const getP2pExecutors = token => request('executors', token);
export const changeP2pExecution = (fieldId, payload, token) => request(`fields/${fieldId}/execution`, token, payload);
export const saveP2pField = (fieldId, payload, token) => request(`fields/${fieldId}`, token, payload);
export const saveP2pProfile = (id, payload, token) => request(id ? `profiles/${id}` : 'profiles', token, payload, id ? 'PUT' : 'POST');

const errors = {
  p2p_recording_in_progress: 'C’è una registrazione già iniziata. Questo passaggio è previsto prima dell’inizio dello slot; attendi la sua conclusione.',
  p2p_worker_not_ready: 'Il server P2P non è pronto. Verifica il collegamento e riprova.',
  p2p_configuration_not_prepared: 'Il server P2P deve prima verificare le impostazioni e gli XML aggiornati di questo campo. La scelta del servizio non è stata cambiata.',
  p2p_configuration_changed: 'Le impostazioni del campo sono cambiate durante la verifica. Attendi il nuovo controllo del server P2P.',
  p2p_configuration_unavailable: 'Non è stato possibile recuperare le impostazioni del campo. La scelta del servizio non è stata cambiata.',
  p2p_nvr_configuration_unconfirmed: 'La configurazione del campo non risulta ancora confermata. Completa la preparazione iniziale prima di attivare P2P.',
  p2p_configuration_camera_mismatch: 'Le telecamere salvate non corrispondono alla configurazione del campo. Controlla le associazioni prima del passaggio.',
  p2p_configuration_source_unverified: 'La vista derivata non ha una sorgente verificata sullo stesso campo.',
  p2p_requested_output_not_supported: 'L’evento richiede un’uscita video che questo servizio P2P non supporta ancora.',
  p2p_nvr_gate_not_prepared: 'Prepara il controllo dei lavori sul solo NVR di questo campo prima del primo passaggio. Dopo la preparazione potrai attivare P2P anche con NVR offline.',
  p2p_single_physical_camera_required: 'Questa prima versione richiede una sola telecamera fisica. Le viste derivate devono avere un’associazione verificata alla sorgente.',
  p2p_execution_unavailable: 'Il passaggio operativo non è ancora disponibile su questo server.',
  p2p_save_configuration_first: 'Salva prima le impostazioni P2P del campo.',
  p2p_encryption_unavailable: 'Il salvataggio protetto delle credenziali non è ancora disponibile. Contatta l’amministratore del servizio.',
  p2p_credentials_unavailable: 'Impossibile leggere la configurazione protetta. Contatta l’amministratore del servizio.',
  p2p_revision_conflict: 'La configurazione è stata modificata da un altro amministratore. Ricarica prima di continuare.',
  p2p_device_already_assigned: 'Questa telecamera e questo canale sono già associati a un campo.',
  p2p_all_cameras_required: 'Configura tutte le telecamere del campo prima di salvare il P2P.',
  p2p_invalid_identity: 'Controlla l’UID della telecamera.',
  p2p_password_required_for_new_device: 'Hai cambiato telecamera: inserisci nuovamente la password.',
  p2p_required_connection_field: 'Compila tutti i dati richiesti dalla telecamera.',
  p2p_invalid_connection_field: 'Uno dei dati di collegamento non è valido.',
  p2p_profile_in_use: 'Questo modello è già utilizzato. Crea un nuovo profilo per una configurazione diversa.',
  p2p_adapter_not_available: 'Il collegamento per questo modello non è ancora disponibile.',
  p2p_invalid_profile: 'Controlla il modello selezionato e i suoi dati.',
  p2p_active_configuration_locked: 'La registrazione P2P è attiva. Il cambio di configurazione richiede un passaggio coordinato del servizio.',
  p2p_camera_not_in_field: 'La telecamera selezionata non appartiene a questo campo.',
  p2p_field_copy_read_only: 'Configura il P2P sul campo originale: questo è un campo copia.',
  p2p_field_not_found: 'Campo non disponibile.',
  admin_required: 'Questa sezione è riservata agli amministratori.'
};
export const p2pErrorMessage = error => errors[error.message] || 'Impossibile completare l’operazione. Riprova.';
